@if (notification(); as currentNotification) {
    <div class="card">
        <h5 class="card-header">{{ currentNotification.notificationText }}</h5>
        <div class="card-body">
            <div class="m-0">
                <span class="font-bold"> {{ notificationType() }} </span>
                {{ currentNotification.identifier.qmNum }} ({{ currentNotification.identifier.maNum }})
            </div>
            @if (currentNotification?.getContactName?.()) {
                <div class="m-0">Contact: {{ currentNotification.getContactName() }}</div>
            }
            @if (currentNotification.getMainEquipment; as mainEquipment) {
                <div class="m-0">
                    Equipment: {{ mainEquipment.tidnr.value }} <span>{{ mainEquipment.equiShortDesc.value }}</span>
                </div>
            }
        </div>

        <div class="card-footer d-flex justify-content-between">
            @if (extraLinks(); as links) {
                @for (link of links; track $index) {
                    <a class="cursor-pointer btn btn-secondary" [routerLink]="link.target" (click)="onLinkClick(link)">
                        @if (link.icon) {
                            <fa-icon class="me-2" [icon]="link.icon"></fa-icon>
                        }
                        {{ link.label }}
                    </a>
                }
            }
        </div>
    </div>
}
